<template>
  <section id="sc_link">
    <!--  标题  -->
    <div class="title text-center">
      <h1><strong>友情链接</strong></h1>
    </div>
    <ul class="logo">
      <li><a href="https://www.1688.com/"><img src="https://grain-120.oss-cn-beijing.aliyuncs.com/friend01.gif"
                                               width="50px" alt="阿里巴巴" title="阿里巴巴"></a></li>
      <li><a href="https://www.google.com/"><img src="https://grain-120.oss-cn-beijing.aliyuncs.com/friend02.gif"
                                                 width="50px" alt="谷歌搜索" title="谷歌搜索"></a></li>
      <li><a href="https://weixin.qq.com/"><img src="https://grain-120.oss-cn-beijing.aliyuncs.com/friend03.gif"
                                                width="50px" alt="微信" title="微信"></a></li>
      <li><a href="https://support.apple.com/zh-cn/guide/mac-help/mchlaab6cfc4/10.14/mac/10.14"><img
        src="https://grain-120.oss-cn-beijing.aliyuncs.com/friend04.gif" width="50px" alt="Finder" title="Finder"></a>
      </li>
      <li><a href="https://weibo.com/"><img src="https://grain-120.oss-cn-beijing.aliyuncs.com/friend05.gif"
                                            width="50px" alt="微博" title="微博"></a></li>
      <li><a href="https://mail.qq.com/"><img src="https://grain-120.oss-cn-beijing.aliyuncs.com/friend06.gif"
                                              width="50px" alt="QQ邮箱" title="QQ邮箱"></a></li>
      <li><a href="https://www.twitter.com/"><img src="https://grain-120.oss-cn-beijing.aliyuncs.com/friend07.gif"
                                                  width="50px" alt=""></a></li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Linkes'
}
</script>

<style scoped>
section{
  padding-top: 20px;
}
#sc_link .logo{
  list-style: none;
  text-align: center;
}

#sc_link .logo li{
  display: inline-block;
  padding: 20px 30px;
}
#sc_link .title h1{
  text-align: center;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Linkes.vue